import { createContext, ReactNode, useContext } from 'react'

export type ModalContextType = {
  close: () => void
}

export const ModalContext = createContext<ModalContextType>({
  close: () => {},
})

export type ModalContextProviderProps = {
  children: ReactNode,
  onClose: () => void
}

export function ModalContextProvider({ children, onClose }: ModalContextProviderProps) {
  const context: ModalContextType = {
    close: onClose,
  }

  return (
    <ModalContext.Provider value={context}>
      {children}
    </ModalContext.Provider>
  )
}

export const useModal = () => {
  const context = useContext(ModalContext)

  if (!context) {
    throw new Error('useModal must be used within a ModalContextProvider')
  }

  return context
}
